import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'NullToDashes',
  standalone: false,
})
export class NullToDashesPipe implements PipeTransform {
  public transform(value: any, length?: number): string {
    const output = length ? '-'.repeat(length) : '--';

    return value === null || value === undefined // tslint:disable-line:no-null-keyword
      ? output
      : value;
  }
}
